import Cookies from 'js-cookie'

function removeByValue(arr, val) {
  for(var i=0; i<arr.length; i++) {
    if(arr[i] == val) {
      arr.splice(i, 1)
      break
    }
  }
}

const app = {
  state: {
    sidebar: {
      opened: !Cookies.get('sidebarStatus')
    },
    visitedViews: [],
    cachedViews: [],
    closedViews:[], /*closedViews用来记录关闭的页面*/
    restoreViews:[],/*restoreViews用来记录页面恢复缓存*/
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    ADD_VISITED_VIEWS: (state, view) => {
      if (state.visitedViews.some(v => v.path === view.path)) {
        return
      }
      state.visitedViews.push({
        name: view.name,
        path: view.path,
        title: view.name || 'no-name'
      })
      if (!view.meta.noCache) {
        state.cachedViews.push(view.name)

        /*加入restoreViews中*/
        if (view.meta && view.meta.noCache) {

          /* 如果页面关闭过，并且没有记录在restoreViews中 */
        }else if(state.closedViews.includes(view.name) && !state.restoreViews.includes(view.name)) {
            /*console.log('add to restoreViews '+view.name)
            console.log('remove from closedViews '+view.name)*/
            state.restoreViews.push(view.name)
        }
        /* 打开页面，总是尝试从closedViews中移除掉 */
        removeByValue(state.closedViews,view.name)
      }
    },
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
      /*加入closedViews中*/
      if (view.meta && view.meta.noCache) {

      }else if(!state.closedViews.includes(view.name)) {
        /*console.log('add to closedViews '+view.name)
        console.log('remove from restoreViews '+view.name)*/
        state.closedViews.push(view.name)
      }
      /*关闭页面，总是尝试从restoreViews中移除掉 */
      removeByValue(state.restoreViews,view.name)
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    addVisitedViews({ commit }, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    }
  }
};

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js